<template>
    <el-drawer title="推送设置" :visible.sync="visible" @close="close" size="1000px" :close-on-press-escape="false"
        :wrapperClosable="false" id="comDrawer" :modal-append-to-body="false">
        <div class="drawerView">
            <div class="drawerViewT">
                <div class="drawerCom">
                    <div class="drawerComL">配置名称：</div>
                    <div class="drawerComR">
                        <el-input v-model="params.configName" placeholder="请输入版本号" style="width: 600px"></el-input>
                    </div>
                </div>
                <div class="drawerCom">
                    <div class="drawerComL">内容模板：</div>
                    <div class="drawerComR">
                        <el-tooltip class="item" effect="dark" content="模板参数,例如:age,应填写'${age}'" placement="top">
                            <el-input v-model="params.templateContent" type="textarea" style="width: 600px"></el-input>
                        </el-tooltip>
                    </div>
                </div>
                <div class="drawerCom">
                    <div class="drawerComL">消息类型：</div>
                    <div class="drawerComR">
                        <el-select v-model="params.configType" placeholder="请选择">
                            <el-option v-for="item in configType" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="drawerCom">
                    <div class="drawerComL">发送对象：</div>
                    <div class="drawerComR">
                        <div>
                            <el-radio-group v-model="params.recipientType" @change="changeClickConfigType">
                                <el-radio label="0" border>不指定</el-radio>
                                <el-radio label="1" border>全部</el-radio>
                                <el-radio label="2" border>指定角色</el-radio>
                                <el-radio label="3" border>指定人</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
                <div class="drawerCom" v-if="params.recipientType==2">
                    <div class="drawerComL">指定角色：</div>
                    <div class="drawerComR">
                        <div>
                       <el-select v-model="positionId" filterable multiple placeholder="请选择" class="titleSelect" size="medium"  @change="handelSearchClick">
              <el-option v-for="item in positionList" :key="item._id" :label="item.name" :value="item.name"/>
        </el-select>
            </div>
                    </div>
                </div>
                <div class="drawerCom" v-if="params.recipientType==3">
                    <div class="drawerComL">指定人：</div>
                    <div class="drawerComR">
                        <div>
                       <el-select v-model="staffId" filterable multiple placeholder="请选择" class="titleSelect" size="medium"  @change="handelSearchClick">
              <el-option v-for="item in staffList" :key="item.id" :label="item.name" :value="item.name"/>
        </el-select>
            </div>
                    </div>
                </div>
                
                <div class="drawerCom">
                    <div class="drawerComL">后续动作：</div>
                    <div class="drawerComR">
                        <div>
                            <el-radio-group v-model="params.clickAction" @change="changeClickConfigAction">
                                <el-radio :label="0" border>无操作</el-radio>
                                <el-radio :label="1" border>应用内跳转</el-radio>
                                <el-radio :label="2" border>启动app</el-radio>
                                <el-radio :label="3" border>打开URL</el-radio>
                                <el-radio :label="4" border>自定义消息</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
                <!-- 推送  消息 才有url -->
                <div class="drawerCom" v-if="params.clickAction === 3 &&
                    (params.configType == 2 || params.configType == 0)
                    ">
                    <div class="drawerComL"></div>
                    <div class="drawerComR">
                        <el-input v-model="params.clickValue_url" placeholder="请输入链接url地址" style="width: 600px">
                        </el-input>
                    </div>
                </div>
                <!-- 推送  应用内调转-->
                <div class="drawerCom" v-if="params.clickAction === 1 && params.configType == 0">
                    <div class="drawerComL"></div>
                    <div class="drawerComR">
                        <el-input v-model="params.clickValue_route" placeholder="请输入应用内的路由"
                            style="width: 600px; margin-bottom: 10px" @input="change($event)"></el-input>
                    </div>
                </div>
                <div v-if="showText">
                    <p style="font-size:12px;color:red;margin-left:150px;margin-top:5px;">
                        样例:intent://com.hscw.peanutpet/XXXX/
                    <ul>
                        <li>1: 必须是以"intent://:"开头</li>
                        <li>2:"com.hscw.peanutpet" 是app的包名 </li>
                        <li>3:"/XXXX/ ",app当中的路径, 必须是app当中真是含有的</li>
                    </ul>
                    </p>
                </div>
                <!-- 消息  应用内调转 选择模板-->
                <div class="drawerCom" v-if="params.clickAction === 1 && params.configType == 2">
                    <div class="drawerComL"></div>
                    <div class="drawerComR">
                        <el-select v-model="params.clickValue_message" placeholder="请选择跳转到模板">
                            <el-option v-for="item in messageRoute" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <!--透传 -->
                <div class="drawerCom" v-if="params.clickAction === 1 && params.configType == 1">
                    <div class="drawerComL"></div>
                    <div class="drawerComR">
                        <el-input v-model="params.clickValue_tou" placeholder="请输入" style="width: 600px"></el-input>
                    </div>
                </div>
  
                <div class="drawerCom">
                    <div class="drawerComL">备注：</div>
                    <div class="drawerComR">
                        <el-input type="textarea" :rows="4" v-model="params.remark" placeholder="请输入备注" style="width: 600px"
                            resize="none"></el-input>
                    </div>
                </div>
                <!-- params.configId.length > 0 -->
                <div class="drawerCom" v-if="params.configId">
                    <div class="drawerComL">模板编号:</div>
                    <div class="drawerComR">
                        <span>{{ params.configId }}</span>
                    </div>
                </div>
            </div>
            <div class="drawerViewB">
                <div class="btn2" @click="close">取消</div>
                <div class="btn" @click="submit">确定</div>
            </div>
        </div>
    </el-drawer>
  </template>
  
  <script>
  export default {
    data() {
        return {
            showText: false,
            visible: true,
            configType: [{
                value: 0,
                label: "通知",
            },
            {
                value: 1,
                label: "透传",
            },
            {
                value: 2,
                label: "消息",
            },
            ],
            messageRoute: [],
            params: {},
            // id:''
            positionId:'',
            positionList:[],
            staffId:'',
            staffList:[],
            handelList:{},
            Elist:[]
        };
    },
    props: {
        id: {
            default: '',
        },
    },
    mounted() {
        // this.getConfigInfo()
        this.getStaffList1()
        this.getPositionData()
        this.visible = true;
        if (this.$public.isNull(this.id)) {
        this.params = {
          configId: "",
          configName: "",
          templateContent: "", // 默认内容
          remark: "",
                    recipientType: "",
                recipientList: {
  
                }
        };
      } else {
                let param = {
                id: this.id
            }
            this.$http.get(process.env.VUE_APP_zichan + '/api/Notice/config/info', param).then(res => {
                if (res.code == 0) {
                    this.params = res.data;
                    if(this.params.recipientType==2){
                        
                        this.positionId=Object.values(this.params.recipientList)
                        this.staffId=[]
                    }else if(this.params.recipientType==3){
                        this.staffId=Object.values(this.params.recipientList)
                        this.positionId=[]
                    }
  
                if (this.params.configType == 0) {
        this.showText = true;
      }
      if (this.params.configType == 1) {
        //推送
        this.params.clickValue_tou = this.params.clickValue;
      } else {
        if (this.params.clickAction == 1) {
          //
          if (this.params.configType == 2) {
            this.params.clickValue_message = this.params.clickValue;
          } else {
            this.params.clickValue_route = this.params.clickValue;
          }
        } else if (this.params.clickAction === 3) {
          //url
  
          this.params.clickValue_url = this.params.clickValue;
        } else {
          this.params.clickValue = "";
        }
      }
                }
            })
  
      }
      
  
        let da = {
            id: "guanggaoweitiaozhuanleixing",
        };
        this.$http
            .get(
                process.env.VUE_APP_AppAdmin + "/api/database/dict/system/single",
                da
            )
            .then((res) => {
                if (res.code == 0) {
                    let daa = res.data;
                    for (let i = 0; i < daa.item_list.length; i++) {
                        this.messageRoute.push({
                            value: daa.item_list[i].item_code,
                            label: daa.item_list[i].item_name,
                        });
                    }
                }
            });
    },
    methods: {
        //获取员工列表
      getPositionData(){
                let params = {
                "keyword": '', //关键字
                "pageIndex": 1,
                "pageSize": 1000,
            }
        this.$http.post(process.env.VUE_APP_Url2 + 'api/dict/StaffType/list',params).then(res => {
          if (res.code == 0) {
            this.positionList = res.data.data
                        
          }
        })
      },
  
        // 获取销售人员列表
        getStaffList1() {
            this.$http.get(process.env.VUE_APP_Url_baseData+'/api/StaffInfo/simple/list').then(res => {
                if (res.code == 0) {
                    res.data.forEach((item) => {
                        const obj = {
                            id: item.value,
                            name: item.label,
                        };
                        this.staffList.push(obj);
                    });
                }
            })
        },
        handelSearchClick(e){
        this.Elist=e
        this.Elist.forEach((item,index)=>{
            this.params.recipientList[`additnalPro${index}`]=item
            })
            this.handelList=this.params.recipientList
  
        },
        change(e) {
            this.$forceUpdate()
        },
  
        changeClickConfigAction(a) {
            this.$forceUpdate();
  
            if (a == "1" && this.params.configType == 0) {
                this.showText = true;
                this.params.clickValue_route = "intent://com.hscw.peanutpet";
            } else {
                this.showText = false;
            }
            this.params.clickValue = '';
        },
        changeClickConfigType(e) {
            if (e == "0") {
                this.params.recipientType = "0",
                    this.params.recipientList = {}
  
            }else if(e=="1"){
                this.params.recipientType = "1",
                    this.params.recipientList = {}
            }else if(e=="2"){
                this.params.recipientType="2",
                this.params.recipientList=this.handelList
            }else if(e=="3"){
                this.params.recipientType="3",
                this.params.recipientList=this.handelList
            }
        },
  
        close() {
            this.$emit("submit", {
                type: "close",
            });
        },
        //提交
        submit() {
            if (this.$public.isNull(this.params.configName)) {
                this.$message({
                    type: "error",
                    message: "配置名称输入有误",
                });
                return;
            }
            if (this.$public.isNull(this.params.templateContent)) {
                this.$message({
                    type: "error",
                    message: "推送内容输入有误",
                });
                return;
            }
            if (this.$public.isNull(this.params.recipientType)) {
                this.$message({
                    type: "error",
                    message: "请选择发送对象",
                });
                return;
            }
            if(this.params.recipientType==2){
                if(JSON.stringify(this.params.recipientList)=='{}'){
                    this.$message({
                    type: "error",
                    message: "请选择指定角色",
                });
                return;
                }
            }else  if(this.params.recipientType==3){
                console.log(this.params.recipientList,"this.params.staffId选择");
                if(JSON.stringify(this.params.recipientList)=='{}'){
                    this.$message({
                    type: "error",
                    message: "请选择指定人",
                });
                return;
                }
            }
  
            //透传
            if (this.params.configType == 1) {
                if (this.params.clickAction == 1) {
                    this.params.clickValue = this.params.clickValue_tou;
                    if (this.$public.isNull(this.params.clickValue)) {
                        this.$message({
                            type: "error",
                            message: "应用内的路由不能为空",
                        });
                        return;
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: "透传只支持应用内跳转",
                    });
                    return;
                }
            } else {
                if (this.params.clickAction === 1) {
                    // 应用内跳转
                    if (this.params.configType == 2) {
                        this.params.clickValue = this.params.clickValue_message;
                    } else {
                        this.params.clickValue = this.params.clickValue_route;
                    }
                    if (this.$public.isNull(this.params.clickValue)) {
                        this.$message({
                            type: "error",
                            message: "应用内的路由不能为空",
                        });
                        return;
                    }
                } else if (this.params.clickAction === 3) {
                    //url
                    this.params.clickValue = this.params.clickValue_url;
                    if (this.$public.isNull(this.params.clickValue)) {
                        this.$message({
                            type: "error",
                            message: "url地址不能为空",
                        });
                        return;
                    }
                } else {
                    //无操作  和 启动app
                    this.params.clickValue = "";
                }
            }
            let params = this.params;
            this.$http
                .post(process.env.VUE_APP_zichan + "/api/Notice/config", params)
                .then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            type: "success",
                            message: "操作成功",
                        });
                        this.$emit("submit", {
                            type: "success",
                        });
                    }
                });
        },
    },
  };
  </script>
  
  <style scoped lang="scss">
  #comDrawer {
    ::v-deep .el-drawer__header {
        padding: 20px;
        margin-bottom: 0;
    }
  
    ::v-deep .el-drawer__body {
        height: calc(100% - 65px);
        overflow-y: auto;
    }
  }
  
  .drawerView {
    height: 100%;
    display: flex;
    flex-direction: column;
  
    .drawerViewT {
        flex: 1;
        box-sizing: border-box;
        border-top: solid 1px #f2f2f2;
        overflow-y: scroll;
  
        .drawerCom {
            display: flex;
            margin-top: 32px;
  
            .drawerComL {
                width: 132px;
                margin-right: 22px;
                font-size: 14px;
                color: #343440;
                text-align: right;
                line-height: 20px;
                margin-top: 12px;
            }
  
            .drawerComR {
                flex: 1;
             line-height: 40px;
                .drawerSelect {
                    display: flex;
  
                    .drawerSelectItem {
                        width: 128px;
                        height: 44px;
                        box-sizing: border-box;
                        font-size: 14px;
                        color: #69697b;
                        text-align: center;
                        line-height: 44px;
                        position: relative;
                        background: #fafafd;
                        border-radius: 8px;
                        margin-right: 16px;
  
                        div:nth-of-type(1) {
                            position: absolute;
                            left: 16px;
                            top: 0;
                            bottom: 0;
                            margin: auto 0;
                            width: 16px;
                            height: 16px;
                            border-radius: 100%;
                            border: solid 1px #b0b0bf;
                        }
                    }
  
                    .drawerSelectActiveItem {
                        width: 128px;
                        height: 44px;
                        box-sizing: border-box;
                        font-size: 14px;
                        color: #577bff;
                        text-align: center;
                        line-height: 44px;
                        position: relative;
                        background: #fafafd;
                        border-radius: 8px;
                        margin-right: 16px;
                        border: 1px solid #577bff;
  
                        div:nth-of-type(1) {
                            position: absolute;
                            left: 16px;
                            top: 0;
                            bottom: 0;
                            margin: auto 0;
                            width: 4px;
                            height: 4px;
                            border-radius: 100%;
                            border: solid 6px #577bff;
                        }
                    }
                }
            }
        }
    }
  
    .drawerViewT::-webkit-scrollbar {
        display: none;
    }
  
    .drawerViewB {
        height: 60px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0 20px;
        border-top: solid 1px #f2f2f2;
        box-sizing: border-box;
  
        .btn {
            width: 98px;
            line-height: 40px;
            text-align: center;
            background: linear-gradient(135deg, #5685ff 0%, #3569ff 100%);
            border-radius: 10px;
            font-size: 16px;
            font-weight: bold;
            color: #fff;
            cursor: pointer;
            margin-left: 20px;
        }
  
        .btn2 {
            width: 98px;
            line-height: 40px;
            text-align: center;
            border-radius: 10px;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
            box-sizing: border-box;
            border: solid 1px #577bff;
            color: #577bff;
        }
    }
  }
  </style>
  